import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectCoverflow, Navigation, Pagination } from "swiper";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import banner_new from '../../_asset/image/banner/banner1.png'
import banner_new_2 from '../../_asset/image/banner/banner2.png'
import banner_1 from '../../_asset/image/banner/new_banner_1.jpg'
import banner_2 from '../../_asset/image/banner/new_banner_2.jpg'
import banner_3 from '../../_asset/image/banner/new_banner_3.jpg'
import banner_4 from '../../_asset/image/banner/new_banner_4.jpg'
import banner_5 from '../../_asset/image/banner/new_banner_5.jpg'
import { actionContext } from "../../apps/page";
import { useContext } from "react";
import { lobbyModalContext } from "../provider/lobby_modal_provider";
import { sexyVendor } from "../../data/gameData_casino";
import { isMobile } from "react-device-detect";
// const bannerList = [
//     banner_1,banner_2,banner_3,banner_4,banner_5,
//     banner_1,banner_2,banner_3,banner_4,banner_5
// ]
const bannerList = [
    banner_new, banner_new_2, banner_new, banner_new_2,
]

export default function BannerSwiper() {
    return (
        <div className={"banner-swiper"}>
            <Swiper
                className='banner-swiper-container'
                slidesPerView={"auto"}
                centeredSlides={true}
                initialSlide={0}

                autoplay={
                    isMobile
                        ? {
                            delay: 2500,
                            disableOnInteraction: false,
                        }
                        : undefined
                }
                loop={true}
                navigation={true}
                pagination={true}
                modules={[Autoplay, Navigation]}>
                {
                    bannerList.map((_, index) => (
                        <SwiperSlide key={index}>
                            <Frame src={bannerList[index]} sexy={[4, 9].includes(index)} />
                        </SwiperSlide>
                    ))
                }
            </Swiper>
        </div>
    )
}
function Frame({ src, sexy }: { src: string, sexy?: boolean }) {
    const { User, SetLoginPop } = useContext(actionContext)
    const { SetLobbyShow, SetVendorInfo, SetType } = useContext(lobbyModalContext)

    function sexyLink() {
        if (User.is_authenticated) {
            if (sexy && sexyVendor) {
                SetLobbyShow()
                SetVendorInfo(sexyVendor)
                SetType('casino')
            }
        } else {
            SetLoginPop()
        }

    }
    return (
        <div className={`banner-items ${sexy && "--pointer"}`} onClick={sexyLink}>
            <div className='banner-image'>
                <img src={src} alt="banner-image" />
            </div>
        </div>
    )
}